import i18n from "i18next";
const HOST =
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_API_ENV !== "production"
    ? "http://localhost:8787/"
    : "https://api.betty.works/";

export async function fetchFromApi(path, options = { headers: {} }) {
  const { expectedResponse, ...fetchOptions } = options;
  const response = await fetch(HOST + path, {
    ...fetchOptions,
    headers: {
      ...options.headers,
      Authorization: `Bearer ${window.location.pathname.slice(1)}`,
    },
  });
  const type = response.headers?.get("content-type") || "";
  const previewHtml = expectedResponse === "league-preview-html" &&
    path === "league-context-preview" && response.ok &&
    /^text\/html(?:;|$)/i.test(type) &&
    /<title>Liga-Kontext · Vorschau<\/title>/i.test(await response.clone().text());
  if (!previewHtml && type && !/application\/(?:[a-z0-9.+-]*\+)?json/i.test(type)) {
    const german = i18n.language?.startsWith("de");
    const error = new Error(german
      ? `Der Server hat keine gültigen API-Daten geliefert (HTTP ${response.status}). Bitte später erneut versuchen.`
      : `The server did not return valid API data (HTTP ${response.status}). Please try again later.`);
    error.code = "API_INVALID_RESPONSE";
    error.status = response.status;
    // Do not include HTML bodies, signed URLs or authentication data.
    throw error;
  }
  return response;
}
